import { render, staticRenderFns } from "./ModalInsert.vue?vue&type=template&id=0747951a&scoped=true"
import script from "./ModalInsert.vue?vue&type=script&lang=js"
export * from "./ModalInsert.vue?vue&type=script&lang=js"
import style0 from "./ModalInsert.vue?vue&type=style&index=0&id=0747951a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747951a",
  null
  
)

export default component.exports